import React, { memo, useMemo } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import AddIcon from 'transfix-icons/build/AddIcon'
import { SingleSelect, ISingleSelectProps } from 'transfix-ui/components/SingleSelect'
import { TEST_IDS } from '../../../../constants'

export interface IMotorCarrierSelectProps
  extends Pick<ISingleSelectProps, 'options' | 'onSelect' | 'selected'> {}

export const ADD_CARRIER_OPTION_VALUE = 'add-carrier'

export const ADD_CARRIER_OPTION: ISelectOption = {
  label: 'Add Carrier',
  value: ADD_CARRIER_OPTION_VALUE,
  icon: <AddIcon size='medium' />,
  isLink: true,
}
const MotorCarrierSelect = memo<IMotorCarrierSelectProps>(
  ({ options = [], onSelect, selected }) => {
    const motorCarrierSelectLabel = useMemo(() => {
      return `${options.length - 1} other carrier${options.length - 1 > 1 ? 's' : ''}`
    }, [options])

    const motorCarrierOptions = [...options, ADD_CARRIER_OPTION]

    return (
      <SingleSelect
        id='carrier-profile-carrier-select'
        dataTest={TEST_IDS.motorCarrierSelect}
        onSelect={onSelect}
        label={motorCarrierSelectLabel}
        options={motorCarrierOptions}
        selected={selected}
        clearable={false}
        showSelectedOptionLabel={false}
      />
    )
  }
)

export default MotorCarrierSelect
